import { images } from '../constants'; 
import { FaClock, FaDollarSign, FaShieldAlt, FaTaxi, FaUsers, FaChartLine, FaBookOpen, FaMoneyBill, FaHandsHelping, FaArrowUp } from "react-icons/fa";


const careerIntro = {
    sub: "Join Our Team",
    heading: "Become a Part of Our Taxi Driving Team",
    description: "At City Taxi Services, we're seeking passionate and reliable drivers to join our team. Discover rewarding career opportunities as a taxi driver and be a part of our mission to provide excellent transportation services. Start your journey with us today and make a difference on the road.",
    points: [
        {
            icon: <FaClock />,
            text: "Flexible Work Hours"
        },
        {
            icon: <FaDollarSign />,
            text: "Competitive Earnings"
        },
        {
            icon: <FaShieldAlt />,
            text: "Driver Safety Training"
        },
        {
            icon: <FaTaxi />,
            text: "Modern Fleet of Vehicles"
        },
        {
            icon: <FaUsers />,
            text: "Supportive Work Environment"
        }
    ],
};

const benefits = [
    {
        id: 1,
        title: "Career Advancement",
        description: "Explore abundant opportunities for career growth and advancement within the taxi service industry.",
        icon: <FaChartLine />  // Growth Icon
    },
    {
        id: 2,
        title: "Training Programs",
        description: "Participate in specialized training programs designed to enhance your skills in customer service and driving practices.",
        icon: <FaBookOpen />  // Training Icon
    },
    {
        id: 3,
        title: "Competitive Pay",
        description: "Enjoy attractive salary packages and benefits in the taxi service sector, providing financial stability.",
        icon: <FaMoneyBill />  // Salary Icon
    },
    {
        id: 4,
        title: "Flexible Hours",
        description: "Benefit from flexible working hours that allow you to balance your personal commitments and lifestyle preferences.",
        icon: <FaClock />  // Clock Icon
    },
    {
        id: 5,
        title: "Team Support",
        description: "Experience a collaborative and supportive team environment, where teamwork and mutual support are encouraged.",
        icon: <FaHandsHelping />  // Hands Icon
    },
    {
        id: 6,
        title: "Growth Potential",
        description: "Unlock significant opportunities for personal and professional growth, with the chance to advance in various roles.",
        icon: <FaArrowUp />  // Growth Icon
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: "Taxi Driver",
        details: {
            location: "Company, City",
            timing: "Full Time",
            hours: "Flexible Hours",
            experience: "Valid Driver’s License & Clean Record",
            position: "Multiple Positions Available",
            days: "Flexible Schedule",
            salary: "$45K - $55K",
            deadline: "Apply Now - Open Until Filled",
            number: "123-456-7890",
        },
        overviews: [
            "Join our team as a Taxi Driver and become part of a dynamic transportation service. Provide safe, reliable, and efficient rides while enjoying flexible working hours and competitive earnings."
        ],
        responsibilities: [
            "Safely transport passengers to their destinations.",
            "Provide excellent customer service and ensure passenger comfort.",
            "Maintain vehicle cleanliness and report any maintenance issues.",
            "Follow traffic laws and company policies.",
            "Utilize GPS navigation and optimize routes for efficiency."
        ],
        qualifications: [
            "Valid driver's license with a clean driving record.",
            "Strong knowledge of local roads and traffic laws.",
            "Good communication and customer service skills.",
            "Ability to work flexible hours, including weekends and holidays.",
            "Previous taxi or rideshare driving experience is a plus."
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: "Dispatcher",
        details: {
            location: "Company, City",
            timing: "Full Time",
            hours: "Standard Business Hours",
            experience: "Prior Dispatch or Customer Service Experience Preferred",
            position: "Multiple Positions Available",
            days: "Monday to Friday",
            salary: "$50K - $60K",
            deadline: "Apply Now - Open Until Filled",
            number: "123-456-7890",
        },
        overviews: [
            "We are seeking a highly organized Dispatcher to coordinate taxi services efficiently. You will manage bookings, communicate with drivers, and ensure timely transportation services. If you thrive in a fast-paced environment, this role is perfect for you!"
        ],
        responsibilities: [
            "Monitor and coordinate taxi dispatch operations.",
            "Assign trips to drivers based on location and availability.",
            "Communicate with customers and drivers via phone or dispatch software.",
            "Ensure timely pickups and drop-offs while optimizing routes.",
            "Handle customer inquiries and provide exceptional service.",
            "Maintain accurate records of trips and driver activity."
        ],
        qualifications: [
            "Previous experience in dispatching or customer service preferred.",
            "Strong communication and multitasking skills.",
            "Ability to work in a fast-paced environment and make quick decisions.",
            "Familiarity with dispatch software and GPS tracking systems.",
            "Excellent problem-solving and organizational skills."
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: "Customer Service Representative",
        details: {
            location: "Company, City",
            timing: "Full Time",
            hours: "Standard Business Hours",
            experience: "Prior Customer Service Experience Preferred",
            position: "Multiple Positions Available",
            days: "Monday to Friday",
            salary: "$40K - $50K",
            deadline: "Apply Now - Open Until Filled",
            number: "123-456-7890",
        },
        overviews: [
            "Join our team as a Customer Service Representative and be the voice of our taxi service. You will handle customer inquiries, assist with bookings, and ensure top-notch service. If you have great communication skills and enjoy helping people, this role is for you!"
        ],
        responsibilities: [
            "Answer customer inquiries via phone, email, and chat.",
            "Assist customers with taxi bookings, cancellations, and modifications.",
            "Provide information on pricing, services, and policies.",
            "Resolve customer complaints and escalate issues as needed.",
            "Maintain accurate records of customer interactions.",
            "Work closely with dispatch and drivers to ensure seamless service."
        ],
        qualifications: [
            "Previous experience in customer service or call center preferred.",
            "Strong verbal and written communication skills.",
            "Ability to multitask and handle high call volumes efficiently.",
            "Problem-solving skills and a customer-first mindset.",
            "Familiarity with booking systems and CRM software is a plus."
        ],
    },


    {
        id: 4,
        image: images.position4,
        title: "Fleet Manager",
        details: {
            location: "Company, City",
            timing: "Full Time",
            hours: "Standard Business Hours",
            experience: "Minimum 3 Years in Fleet Management",
            position: "1 Position Available",
            days: "Monday to Friday",
            salary: "$60K - $75K",
            deadline: "Apply Now - Open Until Filled",
            number: "123-456-7890",
        },
        overviews: [
            "Join our team as a Fleet Manager and oversee the efficient operation of our taxi fleet. You will be responsible for vehicle maintenance, driver coordination, and ensuring compliance with safety regulations. If you have strong leadership skills and experience in fleet operations, this role is perfect for you!"
        ],
        responsibilities: [
            "Manage the daily operations of the taxi fleet, ensuring efficiency and reliability.",
            "Monitor vehicle maintenance schedules and coordinate repairs as needed.",
            "Supervise drivers and enforce company policies and safety standards.",
            "Track fleet performance and optimize routes to enhance service quality.",
            "Ensure compliance with local transportation laws and regulations.",
            "Oversee fuel and expense management to maximize cost efficiency."
        ],
        qualifications: [
            "Proven experience in fleet management or logistics.",
            "Strong leadership and organizational skills.",
            "Knowledge of vehicle maintenance and safety standards.",
            "Proficiency in fleet management software is a plus.",
            "Ability to handle operational challenges in a fast-paced environment."
        ],
    },

    {
        id: 5,
        image: images.position5,
        title: "Operations Coordinator",
        details: {
            location: "Company, City",
            timing: "Full Time",
            hours: "Standard Business Hours",
            experience: "Minimum 2 Years in Operations Management",
            position: "1 Position Available",
            days: "Monday to Friday",
            salary: "$55K - $70K",
            deadline: "Apply Now - Open Until Filled",
            number: "123-456-7890",
        },
        overviews: [
            "We are looking for a detail-oriented and proactive Operations Coordinator to oversee daily business functions. In this role, you'll ensure smooth operations, improve service efficiency, and support our team in delivering top-notch taxi services."
        ],
        responsibilities: [
            "Monitor and coordinate daily taxi operations to ensure efficiency.",
            "Optimize dispatch schedules and driver assignments for smooth workflow.",
            "Handle customer inquiries and resolve operational issues quickly.",
            "Assist in managing compliance with transportation regulations.",
            "Analyze service performance data and suggest process improvements.",
            "Work closely with drivers, dispatchers, and management to enhance operations."
        ],
        qualifications: [
            "Experience in operations management, preferably in transportation or logistics.",
            "Strong organizational and multitasking abilities.",
            "Proficiency in operations management software and tools.",
            "Excellent communication and problem-solving skills.",
            "Ability to work in a fast-paced, team-oriented environment."
        ],
    },
];





export { positions, benefits, careerIntro };